import currencyFormatter from "@/utils/currencyFormat";
import { useSelector, shallowEqual } from "react-redux";

const useCurrency = (propertyPrice = 0) => {
  const { currencyRateList, selectedCurrency } = useSelector(
    (state) => state.auth,
    shallowEqual
  );

  const rate = currencyRateList?.[selectedCurrency]?.exchangeRates ?? 1;

  const calculatedValue = rate * propertyPrice;

  const currency = currencyFormatter(Math.round(calculatedValue));

  const symbol =
    currencyRateList?.[selectedCurrency]?.targetCurrencySymbol ?? "USD";

  const code =
    currencyRateList?.[selectedCurrency]?.targetCurrencyCode ?? "USD";

  return {
    rate,
    calculatedValue,
    currency,
    symbol,
    code
  };
};

export default useCurrency;
